import {default as pluginRspackEmpShare} from 'src/plugins/rspack'
export default pluginRspackEmpShare
export * from 'src/plugins/rspack'
